import { PropsWithChildren } from "react"
import { ThemeProvider } from '@mui/material/styles';
import { SISDefaultTheme, SisLibraryProviders } from "@sis/react-library";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../../authConfig";
import { SampleDataProvider } from "../sampleData/SampleDataProvider";

export const ProjectProviders = ({
    children
}: PropsWithChildren) => {

    const msalInstance = new PublicClientApplication(msalConfig);
    const theme = SISDefaultTheme;

    return (
        <MsalProvider instance={msalInstance}>
            <ThemeProvider theme={theme}>
                <SisLibraryProviders theme={theme}>
                    <SampleDataProvider>
                        {children}
                    </SampleDataProvider>
                </SisLibraryProviders>
            </ThemeProvider>
        </MsalProvider>
    )
}
